import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-dark py-10 border-t border-coral-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-4">
          {/* Logo */}
          <img
            src="/images/logo.webp"
            alt="Develop in Rest"
            className="h-12 w-auto rounded-lg"
          />
          
          {/* Brand Name */}
          <div className="font-serif text-white text-xl">
            Develop in Rest
          </div>
          
          {/* Copyright Text */}
          <div className="text-center">
            <p className="text-gray-400">
              © {currentYear} Develop in Rest. All rights reserved.
            </p>
            <p className="text-sm text-coral-400 mt-1">
              Built on Kindness. Romans 2:1-4
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;